var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseControl',_vm._b({staticClass:"mt-1"},'BaseControl',_vm.$attrs,false),[_c('date-picker',{attrs:{"value":_vm.range,"lang":_vm.lang,"range":"","type":"date","format":"DD.MM.YYYY"},on:{"input":_vm.updateRange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }